export const isProduction = () => process.env.REACT_APP_ENV === 'prod';
export const isStaging = () => process.env.REACT_APP_ENV === 'stg';
export const apiBaseURL = () =>
  process.env.REACT_APP_GLOBIS_API_BASE_URL?.replace(/\/+$/, '') || '';
